/* import __COLOCATED_TEMPLATE__ from './target-audience-paywalled-select-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();